export const cipWhitelist = [
  '000993883',
  '666003885',
  '666990000',
  '999013890',
  '666993887',
  '666993884',
  '666993889',
  '666993888',
  '666993882',
  '666980662',
  '666980661',
  '666123732',
  '666990165',
  '666990162',
  '666990558',
  '666990251',
  '666462976',
  '666993631',
  '666993839',
  '666628772',
  '666224444',
  '666993881',
  '666993880',
  '666712490',
  '666883071',
  '666231739',
  '666231714',
  '666991273',
  '666991274',
  '666970007',
  '666970036',
  '666950001',
  '666950041',
  '666990388',
  '666990339',
  '666990350',
  '666990371',
  '666990376',
  '666990370',
  '666990393',
  '666990389',
  '666863004',
  '666263983',
  '666993840',
  '666993841',
  '666993842',
  '666993843',
  '666990197',
  '666585540',
  '666990351',
  '666990352',
  '666993867',
  '666993868',
  '666010102',
  '666020021',
  '666020029',
  '666028788',
  '666028032',
  '666011442',
  '666012015',
  '666027972',
  '666330657',
  '666100032',
  '666840024',
  '666993865',
  '666993858'
];
